import client from "@/services/rest/client";

export function ping() {
  const method = "get";
  const url = "/public/ping";

  return client({ method, url });
}
